export { default } from './SectionTabs';
export * from './SectionTabs';
